/**
 * ScaffoldedCharacter schema (from world creation wizard)
 * Mirrors backend src/schemas/agents/scaffolding/character-enricher.ts
 */

import { z } from 'zod';

export const ScaffoldedCharacterSchema = z.object({
  name: z.string(),
  isPlayerCharacter: z.boolean(),
  physicalDescription: z.string().nullable(),
  movementQuality: z.string().nullable(),
  primaryDrive: z.string().nullable(),
  coreWound: z.string().nullable(),
  defenseMechanisms: z.array(z.string()),
  blindSpots: z.array(z.string()),
  intelligenceSignature: z.string().nullable(),
  decisionArchitecture: z.string().nullable(),
  knowledgeDomains: z.array(z.string()),
  observableHabits: z.array(z.string()),
  stressResponse: z.string().nullable(),
  socialCalibration: z.string().nullable(),
  speechPatterns: z.string().nullable(),
  attachmentStyle: z.string().nullable(),
  powerOrientation: z.string().nullable(),
  trustCalculus: z.string().nullable(),
  surfaceGoals: z.array(z.string()),
  hiddenGoals: z.array(z.string()),
  secrets: z.array(z.string()),
  currentEmotionalState: z.string().nullable(),
  activeConcerns: z.array(z.string()),
  roleInStory: z.string().nullable(),
  age: z.string().nullable(),
  background: z.string().nullable(),
});

export type ScaffoldedCharacter = z.infer<typeof ScaffoldedCharacterSchema>;

/**
 * ScaffoldedFact schema (from world creation wizard)
 */
export const ScaffoldedFactSchema = z.object({
  subject: z.string(),
  predicate: z.string(),
  object: z.string(),
  category: z.enum(['world', 'character', 'object', 'rule']),
});

export type ScaffoldedFact = z.infer<typeof ScaffoldedFactSchema>;
